import { useLocation, useNavigate } from "react-router-dom";
import Config from "../config/config";
import { useLocale } from "../context/LocaleProvider";

function ContactForm() {
    let navigate = useNavigate();
    let location = useLocation();
    const { t } = useLocale();
    const handleClick = function() {
        navigate(`/contact?rurl=${encodeURIComponent(location.pathname)}`)
    }
    return (<>
        <div className="block3 text-center clickable pt-4 pb-4" onClick={handleClick}>
            <p className="p-0 m-0 mt-1 mb-1 fst-italic">{t("contact_form.title.line1")}</p>
            <p className="p-0 m-0 mt-1 mb-1 fst-italic">{t("contact_form.title.line2")}</p>
            <p className="p-0 m-0 mt-1 mb-1 fst-italic">{t("contact_form.subtitle", {project_name: Config.app.siteName})}</p>
        </div>
    </>)

}

export default ContactForm;